/** Base pulse block — compose into page-specific skeletons below.
 * Design System 2.0 (2026-10, Phase 1): tokenized colors, radius 6 cards. */
function Bone({ className = "" }) {
  return <div className={`animate-pulse rounded bg-surface2 ${className}`} />;
}

export function TableSkeleton({ rows = 6, cols = 5, testId }) {
  return (
    <div className="rounded-md border border-hairline bg-paper overflow-hidden" data-testid={testId}>
      <div className="border-b border-hairline px-4 py-3"><Bone className="h-3 w-40" /></div>
      <div className="divide-y divide-hairline">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-6 px-4 py-3.5">
            {Array.from({ length: cols }).map((__, j) => (
              <Bone key={j} className={`h-3 ${j === 0 ? "w-32" : "w-16"}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function CardGridSkeleton({ count = 6, testId }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid={testId}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-md border border-hairline bg-paper p-4 space-y-3">
          <Bone className="h-4 w-2/3" />
          <Bone className="h-2 w-full" />
          <Bone className="h-2 w-1/2" />
        </div>
      ))}
    </div>
  );
}

export function DetailSkeleton({ testId }) {
  return (
    <div className="p-8 space-y-8" data-testid={testId}>
      <div className="space-y-3">
        <Bone className="h-8 w-64" />
        <Bone className="h-3 w-40" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {Array.from({ length: 3 }).map((_, i) => <Bone key={i} className="h-20 w-full" />)}
      </div>
      <Bone className="h-40 w-full" />
    </div>
  );
}
